// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import Swal from "sweetalert2"; // Import SweetAlert2
// import {
//   Modal,
//   Button,
//   Table,
//   Form,
//   Row,
//   Col,
//   InputGroup,
//   FormControl,
// } from "react-bootstrap";
// import InfoModal from "../model/InfoModal"; // Import the modal component
// import { Modal, Button, Table, Form, Row, Col } from "react-bootstrap";

import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { Modal, Button, Table, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { usePortalScope } from "../context/PortalScopeContext";
import "../styles/VendorTable.css";

const VendorTable = () => {
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [actions, setActions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSavingVendor, setIsSavingVendor] = useState(false);
  const [sources, setSources] = useState([]);
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedExportCountries, setSelectedExportCountries] = useState([]);
  const [editingVendor, setEditingVendor] = useState({
    SourceId: "",
    CompanyName: "",
    FirstName: "",
    LastName: "",
    CategoryId: "",
    SubCategoryId: "",
    Contact: "",
    Email: "",
    Website: "",
    Country: "",
    ExportCountries: "",
    Comments: "",
    Priority: "",
    Status: "",
  });
  const [newAction, setNewAction] = useState({
    Action: "",
    Remark: "",
  });
  const [searchText, setSearchText] = useState("");
  const [priorityFilter, setPriorityFilter] = useState("");
  const [sourceFilter, setSourceFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [CommunicationModeFilter, setCommunicationModeFilter] = useState("");
  const [fileName, setFileName] = useState("");
  const [selectedFields, setSelectedFields] = useState([
    "SourceName",
    "CompanyName",
    "FirstName",
    "LastName",
    "Email",
    "Contact",
    "CategoryName",
    "Status",
    "DateTime",
  ]);
  const [history, setHistory] = useState([]);
  const [expandedRequirements, setExpandedRequirements] = useState(new Set());
  const api_url = process.env.REACT_APP_API_URL;
  const { scopeParam, canSwitchPortal, portalScope } = usePortalScope();

  const toggleRequirements = (vendorId) => {
    setExpandedRequirements((prev) => {
      const next = new Set(prev);
      next.has(vendorId) ? next.delete(vendorId) : next.add(vendorId);
      return next;
    });
  };

  const parseRequirements = (raw) => {
    try {
      return typeof raw === "string"
        ? JSON.parse(raw)
        : Array.isArray(raw)
          ? raw
          : [];
    } catch {
      return [];
    }
  };

  useEffect(() => {
    const fetchVendors = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found. User may not be logged in.");
        return;
      }

      try {
        const { data } = await axios.get(`${api_url}/api/vendor${scopeParam}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (Array.isArray(data)) {
          setVendors(data);
        } else {
          console.error("Invalid vendor data received");
        }
      } catch (error) {
        console.error("Error fetching vendor data:", error);
      }
    };

    fetchVendors();
  }, [api_url, scopeParam]);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found. User may not be logged in.");
          return;
        }

        const response = await axios.get(
          `${api_url}/api/vendor/History${scopeParam}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (Array.isArray(response.data)) {
          setHistory(response.data);
        } else {
          console.error("Invalid vendor history data received");
        }
      } catch (error) {
        console.error("Error fetching vendor history:", error);
      }
    };

    fetchHistory();
  }, [api_url, scopeParam]);

  useEffect(() => {
    const fetchEditLookups = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const [sourceRes, categoryRes] = await Promise.all([
          axios.get(`${api_url}/api/source${scopeParam}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${api_url}/api/category${scopeParam}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setSources(Array.isArray(sourceRes.data) ? sourceRes.data : []);
        setCategories(Array.isArray(categoryRes.data) ? categoryRes.data : []);
      } catch (error) {
        console.error("Error loading edit dropdown data:", error);
      }
    };

    fetchEditLookups();
  }, [api_url, scopeParam]);

  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all?fields=name")
      .then((response) => response.json())
      .then((data) => {
        const countryNames = data
          .map((country) => country?.name?.common)
          .filter(Boolean)
          .sort((a, b) => a.localeCompare(b));
        setCountries(
          countryNames.map((name) => ({ value: name, label: name })),
        );
      })
      .catch((error) => console.error("Error fetching countries:", error));
  }, []);

  const getSubCategoryOptions = (categoryId) => {
    const selectedCategory = categories.find(
      (cat) => String(cat.CategoryId) === String(categoryId),
    );

    if (
      !selectedCategory ||
      !selectedCategory.SubCategories ||
      selectedCategory.SubCategories === "null"
    ) {
      return [];
    }

    const names = selectedCategory.SubCategories.split(",").map((s) =>
      s.trim(),
    );
    const ids = (selectedCategory.SubCatIDs || "")
      .split(",")
      .map((s) => s.trim());

    return names.map((name, idx) => ({
      id: ids[idx] || "",
      name,
    }));
  };

  const handleEditVendor = (vendor) => {
    setSelectedVendor(vendor);
    const exportCountries = (vendor.ExportCountries || "")
      .split(",")
      .map((c) => c.trim())
      .filter(Boolean);

    setEditingVendor({
      SourceId: vendor.SourceId ? String(vendor.SourceId) : "",
      CompanyName: vendor.CompanyName || "",
      FirstName: vendor.FirstName || "",
      LastName: vendor.LastName || "",
      CategoryId: vendor.CategoryId ? String(vendor.CategoryId) : "",
      SubCategoryId: vendor.SubCategoryId ? String(vendor.SubCategoryId) : "",
      Contact: vendor.Contact || "",
      Email: vendor.Email || "",
      Website: vendor.Website || "",
      Country: vendor.Country || "",
      ExportCountries: vendor.ExportCountries || "",
      Comments: vendor.Comments || "",
      Priority: vendor.Priority || "",
      Status: vendor.Status || "",
    });
    setSelectedExportCountries(exportCountries);
    setIsEditMode(false);
    setShowEditModal(true);
  };

  const handleSaveVendor = async () => {
    if (!selectedVendor?.VendorId || isSavingVendor) return;

    const token = localStorage.getItem("token");
    setIsSavingVendor(true);

    try {
      await axios.put(
        `${api_url}/api/vendor/${selectedVendor.VendorId}`,
        editingVendor,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} },
      );

      setVendors((prev) =>
        prev.map((vendor) =>
          vendor.VendorId === selectedVendor.VendorId
            ? {
                ...vendor,
                ...editingVendor,
                SourceName:
                  sources.find(
                    (s) => String(s.Id) === String(editingVendor.SourceId),
                  )?.SourceName || vendor.SourceName,
                CategoryName:
                  categories.find(
                    (c) =>
                      String(c.CategoryId) === String(editingVendor.CategoryId),
                  )?.Category || vendor.CategoryName,
                Sub_Categories:
                  getSubCategoryOptions(editingVendor.CategoryId).find(
                    (sc) =>
                      String(sc.id) === String(editingVendor.SubCategoryId),
                  )?.name || "",
              }
            : vendor,
        ),
      );

      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Vendor details updated successfully.",
        showConfirmButton: false,
        timer: 1500,
      });

      setShowEditModal(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Update failed",
        text:
          error.response?.data?.message ||
          "Failed to update vendor details. Please try again.",
      });
    } finally {
      setIsSavingVendor(false);
    }
  };

  //     useEffect(() => {
  //     axios.get('http://localhost:5050/api/vendor')
  //       .then((response) => {
  //         if (response.data && Array.isArray(response.data)) {
  //           setRecords(response.data);
  //         } else {
  //           console.error('Invalid data received');
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error fetching data:', error);
  //       });
  //   }, []);

  // Function to determine status color
  const getStatusColor = (status) => {
    switch (status) {
      case "Order Volumes & Prices Sent":
        return "bg-info text-white";
      case "Waiting for Price & Volume Confirmation":
        return "bg-warning text-dark";
      case "Order Received":
        return "bg-primary text-white";
      case "Porforma Invoice(PI) Sent":
        return "bg-secondary text-white";
      case "PI Accepted":
        return "bg-success text-white";
      case "Order advanced payment Received":
        return "bg-dark text-white";
      case "Sent the shipping plan":
        return "bg-primary text-white";
      case "Shipped / Dispatched":
        return "bg-success text-white";
      case "Order Successful":
        return "bg-success text-white";
      default:
        return "bg-secondary text-white";
    }
  };

  // Function to export selected data to Excel
  // const exportToExcel = () => {
  //     const filteredData = vendors.map(({ SourceName, CompanyName, FirstName, LastName, Email, Website, Contact, Status }) => ({
  //         "Source Name": SourceName,
  //         "Company Name": CompanyName,
  //         "First Name": FirstName,
  //         "Last Name": LastName,
  //         "Email": Email,
  //         "Website": Website,
  //         "Contact": Contact,
  //         "Status": Status
  //     }));

  //     const ws = XLSX.utils.json_to_sheet(filteredData);
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Vendors");
  //     XLSX.writeFile(wb, "Vendor_Data.xlsx");
  // };

  const fetchActions = async (vendor) => {
    setSelectedVendor(vendor);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${api_url}/api/vendorActions/${vendor.VendorId}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} },
      );
      setActions(response.data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching actions:", error);
    }
  };

  const handleAddAction = async (e) => {
    e.preventDefault();
    const currentDateTime = new Date();

    // Adjust the date to Sri Lanka time (UTC +5:30)
    const sriLankaTime = new Date(
      currentDateTime.toLocaleString("en-US", { timeZone: "Asia/Colombo" }),
    );

    const token = localStorage.getItem("token");
    try {
      // Send the correct VendorId, newAction data, and the current Sri Lanka time as ISO string
      await axios.post(
        `${api_url}/api/vendorActions`,
        {
          VendorId: selectedVendor.VendorId,
          ...newAction,
          Date: sriLankaTime.toISOString(),
        },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} },
      );

      // Update the vendor's status with the latest action
      await axios.put(
        `${api_url}/api/vendor/Status/${selectedVendor.VendorId}`,
        { Status: newAction.Action },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} },
      );

      fetchActions(selectedVendor);
      setNewAction({ Action: "", Remark: "" });
    } catch (error) {
      console.error("Error adding action:", error);
    }
  };

  const updateCommunicationMode = async (vendorId, newMode) => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${api_url}/api/vendor/Com/${vendorId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ CommunicationMode: newMode }),
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Communication mode updated successfully.",
          showConfirmButton: false,
          timer: 1500,
        });

        setVendors((prev) =>
          prev.map((vendor) =>
            vendor.VendorId === vendorId
              ? { ...vendor, CommunicationMode: newMode }
              : vendor,
          ),
        );

        setSelectedVendor((prev) =>
          prev && prev.VendorId === vendorId
            ? { ...prev, CommunicationMode: newMode }
            : prev,
        );
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update communication mode.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while updating the communication mode.",
      });
      console.error("Error updating communication mode:", error);
    }
  };

  // Define available fields
  const availableFields = [
    { key: "SourceName", label: "Source Name" },
    { key: "CompanyName", label: "Company Name" },
    { key: "FirstName", label: "First Name" },
    { key: "LastName", label: "Last Name" },
    { key: "Email", label: "Email" },
    { key: "Contact", label: "Contact" },
    // { key: 'Country', label: 'Country' },
    { key: "CategoryName", label: "Category" },
    { key: "Status", label: "Status" },
    { key: "DateTime", label: "Date & Time" },
  ];

  // Filter Data based on searchText, Priority & SourceName
  const filteredRecords = vendors.filter((record) => {
    return (
      (priorityFilter ? record.Priority === priorityFilter : true) &&
      (sourceFilter ? record.SourceName === sourceFilter : true) &&
      (statusFilter ? record.Status === statusFilter : true) &&
      (CommunicationModeFilter
        ? record.CommunicationMode === CommunicationModeFilter
        : true) && // Added Communication Mode filter
      ((record.Customer ? record.Customer.toLowerCase() : "").includes(
        searchText.toLowerCase(),
      ) ||
        (record.Country ? record.Country.toLowerCase() : "").includes(
          searchText.toLowerCase(),
        ) ||
        (record.Source ? record.Source.toLowerCase() : "").includes(
          searchText.toLowerCase(),
        ) ||
        (record.CategoryName ? record.CategoryName.toLowerCase() : "").includes(
          searchText.toLowerCase(),
        ) ||
        (record.Contact
          ? record.Contact.toString().includes(searchText)
          : false) ||
        (record.Email ? record.Email.toLowerCase() : "").includes(
          searchText.toLowerCase(),
        ) ||
        (record.CompanyName ? record.CompanyName.toLowerCase() : "").includes(
          searchText.toLowerCase(),
        ))
    );
  });

  // Helper: log a client-side event to the audit API
  const logClientEvent = async (action, details) => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${api_url}/api/audit/log`,
        { action, entityType: "VendorForm", details },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} },
      );
    } catch (err) {
      console.error("[Audit] Failed to log client event:", err.message);
    }
  };

  // Export data to Excel
  const exportToExcel = async () => {
    if (filteredRecords.length === 0) {
      alert("No records to export.");
      return;
    }

    const selectedData = filteredRecords.map((record) => {
      let obj = {};
      selectedFields.forEach((field) => {
        obj[field] = record[field] || "N/A";
      });

      // Append requirements as individual columns (e.g. "Req: Inventory", "Req: Contract")
      const reqs = parseRequirements(record.Requirements);
      if (reqs.length > 0) {
        reqs.forEach((r) => {
          obj[`Req: ${r.Name}`] = r.Value ?? "";
        });
      }

      return obj;
    });

    const customFileName = fileName.trim()
      ? `${fileName}.xlsx`
      : "Vendor_Report.xlsx";
    const ws = XLSX.utils.json_to_sheet(selectedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendors");
    XLSX.writeFile(wb, customFileName);
    await logClientEvent("EXPORT_EXCEL", {
      fileName: customFileName,
      recordCount: filteredRecords.length,
      fields: selectedFields,
    });
  };

  // Function to export vendor history data to Excel
  const exportHistoryToExcel = async () => {
    if (history && history.length > 0) {
      const ws = XLSX.utils.json_to_sheet(history);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Vendor History");
      const customFileName = fileName.trim()
        ? `${fileName}.xlsx`
        : "Vendor_Report.xlsx";
      XLSX.writeFile(wb, customFileName);
      await logClientEvent("EXPORT_HISTORY_EXCEL", {
        fileName: customFileName,
        recordCount: history.length,
      });
    } else {
      console.error("No data to export.");
    }
  };

  return (
    <div className="container-fluid my-4 px-4">
      <div className="vt-page-card">
        {/* Heading bar */}
        <div className="vt-heading-bar">
          <h4>
            <i className="bi bi-table me-2"></i>Vendor Table
          </h4>
          {canSwitchPortal && (
            <span className="badge">
              <i className="bi bi-globe2 me-1"></i>Viewing: {portalScope} portal
            </span>
          )}
        </div>

        {/* Filters */}
        <div className="vt-filter-section">
          <div className="row g-3 align-items-center mb-2">
            <div className="col-md-3">
              <select
                className="form-select"
                value={priorityFilter}
                onChange={(e) => setPriorityFilter(e.target.value)}
              >
                <option value="">All Priorities</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                value={sourceFilter}
                onChange={(e) => setSourceFilter(e.target.value)}
              >
                <option value="">All Sources</option>
                {Array.from(new Set(vendors.map((rec) => rec.SourceName))).map(
                  (source) => (
                    <option key={source} value={source}>
                      {source}
                    </option>
                  ),
                )}
              </select>
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">All Statuses</option>
                {[
                  "Order Volumes & Prices Sent",
                  "Waiting for Price & Volume Confirmation",
                  "Order Received",
                  "Porforma Invoice(PI) Sent",
                  "PI Accepted",
                  "Order advanced payment Received",
                  "Sent the shipping plan",
                  "Shipped / Dispatched",
                  "Order Successful",
                  "Other",
                ].map((s, i) => (
                  <option key={i} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                value={CommunicationModeFilter}
                onChange={(e) => setCommunicationModeFilter(e.target.value)}
              >
                <option value="">All Communication Mode</option>
                {["Unknown", "WhatsApp", "Email", "W & E"].map((s, i) => (
                  <option key={i} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <input
                type="text"
                className="form-control"
                placeholder="Custom File Name"
                value={fileName}
                onChange={(e) => setFileName(e.target.value)}
              />
            </div>
          </div>
          {/* Field Selection */}
          <div className="mb-1">
            <label
              className="form-label mb-1"
              style={{
                fontSize: "0.78rem",
                fontWeight: 600,
                color: "#c95f00",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Select Fields to Export
            </label>
            <div className="d-flex flex-wrap gap-1">
              {availableFields.map((field) => (
                <div key={field.key} className="form-check mx-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedFields.includes(field.key)}
                    onChange={() =>
                      setSelectedFields((prev) =>
                        prev.includes(field.key)
                          ? prev.filter((f) => f !== field.key)
                          : [...prev, field.key],
                      )
                    }
                  />
                  <label
                    className="form-check-label"
                    style={{ fontSize: "0.8rem" }}
                  >
                    {field.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* end vt-filter-section */}

        {/* Additional Buttons on Top */}
        <div className="vt-export-bar">
          <Button variant="success" onClick={exportToExcel}>
            Export to Excel
          </Button>
          <Button variant="success" onClick={exportHistoryToExcel}>
            Export History to Excel
          </Button>

          <Button
            variant="warning"
            onClick={() => {
              setSearchText("");
              setPriorityFilter("");
              setSourceFilter("");
              setStatusFilter("");
              setCommunicationModeFilter("");
            }}
          >
            Clear All
          </Button>
        </div>
        {/* end export bar */}

        {/* Search Field */}
        <div
          style={{
            padding: "10px 20px 12px",
            background: "#fafafa",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <input
            type="text"
            className="form-control"
            style={{
              borderColor: "#f0c078",
              borderRadius: "8px",
              fontSize: "0.85rem",
            }}
            placeholder="🔍  Search by company, email, contact..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        {/* Table */}
        <div className="vendor-table-wrapper">
          <table className="vendor-table">
            <thead>
              <tr>
                <th className="col-num">#</th>
                {canSwitchPortal && <th className="col-portal">Portal</th>}
                <th className="col-source">Source Name</th>
                <th className="col-company1">Company Name</th>
                <th className="col-name">Full Name</th>
                <th className="col-email">Email</th>
                <th className="col-phone">Phone</th>
                {/* <th>Country</th> */}
                <th className="col-commode">Communication Mode</th>
                <th className="col-status">Status</th>
                <th className="col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((vendor, index) => {
                const isLocal = (vendor.Scope || portalScope) === "Local";
                const reqs = isLocal
                  ? parseRequirements(vendor.Requirements)
                  : [];
                const isExpanded = expandedRequirements.has(vendor.VendorId);
                return (
                  <React.Fragment key={vendor.VendorId}>
                    <tr>
                      <td className="col-num" data-label="#">
                        {index + 1}
                      </td>
                      {canSwitchPortal && (
                        <td className="col-portal" data-label="Portal">
                          <span
                            className={`badge ${(vendor.Scope || portalScope) === "Local" ? "bg-secondary" : "bg-info"}`}
                          >
                            {vendor.Scope || portalScope}
                          </span>
                        </td>
                      )}
                      <td
                        className="col-source"
                        data-label="Source Name"
                        title={vendor.SourceName}
                      >
                        {vendor.SourceName}
                      </td>
                      <td
                        className="col-company"
                        data-label="Company Name"
                        title={vendor.CompanyName}
                      >
                        {vendor.CompanyName}
                      </td>
                      <td
                        className="col-name"
                        data-label="Full Name"
                        title={`${vendor.FirstName} ${vendor.LastName}`}
                      >
                        {vendor.FirstName} {vendor.LastName}
                      </td>
                      <td
                        className="col-email"
                        data-label="Email"
                        title={vendor.Email}
                      >
                        <a
                          href={`mailto:${vendor.Email || ""}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          {vendor.Email || "N/A"}
                        </a>
                      </td>
                      <td className="col-phone" data-label="Phone">
                        <a
                          href={
                            vendor.Contact
                              ? `https://wa.me/${vendor.Contact}`
                              : "#"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          {vendor.Contact || "N/A"}
                        </a>
                      </td>
                      {/* <td>{vendor.Country}</td> */}
                      <td className="col-commode" data-label="Comm. Mode">
                        <select
                          value={vendor.CommunicationMode}
                          onChange={(e) =>
                            updateCommunicationMode(
                              vendor.VendorId,
                              e.target.value,
                            )
                          }
                          className="form-select"
                        >
                          <option value={vendor.CommunicationMode}>
                            {vendor.CommunicationMode}
                          </option>
                          {/* <option value="Unknown">Unknown</option> */}
                          <option value="WhatsApp">WhatsApp</option>
                          <option value="Email">Email</option>
                          <option value="W & E">WhatsApp & Email</option>
                        </select>
                      </td>

                      <td className="col-status" data-label="Status">
                        <span
                          className={`badge ${getStatusColor(vendor.Status)}`}
                        >
                          {vendor.Status}
                        </span>
                      </td>
                      <td className="col-actions" data-label="Actions">
                        <div className="d-flex gap-2">
                          {/* History Button */}
                          <Button
                            variant="primary"
                            className="btn-sm"
                            type="button"
                            onClick={() => fetchActions(vendor)}
                          >
                            <i className="bi bi-clock-history"></i>
                          </Button>

                          {/* View Details Button */}
                          <Button
                            variant="success"
                            className="btn-sm view-details-btn"
                            type="button"
                            onClick={() => handleEditVendor(vendor)}
                            title="View vendor details"
                          >
                            <i className="bi bi-eye"></i>
                          </Button>

                          {/* Requirements Toggle — Local only */}
                          {isLocal && reqs.length > 0 && (
                            <Button
                              variant={isExpanded ? "warning" : "info"}
                              className="btn-sm"
                              type="button"
                              title={
                                isExpanded
                                  ? "Hide Requirements"
                                  : "View Requirements"
                              }
                              onClick={() =>
                                toggleRequirements(vendor.VendorId)
                              }
                              style={{ color: "#fff" }}
                            >
                              <i
                                className={`bi ${isExpanded ? "bi-chevron-up" : "bi-list-check"}`}
                              ></i>
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                    {/* Expandable requirements row */}
                    {isLocal && isExpanded && reqs.length > 0 && (
                      <tr className="requirements-row">
                        <td
                          colSpan={canSwitchPortal ? 10 : 9}
                          style={{ padding: "10px 20px 14px" }}
                        >
                          <div className="d-flex align-items-center gap-2 mb-2">
                            <i className="bi bi-list-check text-primary"></i>
                            <span
                              className="fw-semibold"
                              style={{
                                color: "#ff7f50",
                                fontSize: "0.82rem",
                                letterSpacing: "0.04em",
                                textTransform: "uppercase",
                              }}
                            >
                              Requirements
                            </span>
                            {vendor.CategoryName && (
                              <span
                                style={{
                                  fontSize: "0.82rem",
                                  color: "#ff7f50",
                                  fontWeight: 600,
                                }}
                              >
                                — {vendor.CategoryName}
                              </span>
                            )}
                          </div>
                          <table className="req-subtable w-auto">
                            <thead>
                              <tr>
                                <th style={{ minWidth: "180px" }}>Type</th>
                                <th style={{ minWidth: "120px" }}>Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reqs.map((r, i) => (
                                <tr key={i}>
                                  <td>{r.Name}</td>
                                  <td>{r.Value}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>

        <Modal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          size="lg"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isEditMode
                ? `Edit Vendor: ${selectedVendor?.CompanyName || ""}`
                : `Vendor Details: ${selectedVendor?.CompanyName || ""}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!isEditMode && selectedVendor && (
              <table className="table table-bordered table-sm">
                <tbody>
                  <tr>
                    <th style={{ width: "40%" }}>Source Name</th>
                    <td>
                      {sources.find(
                        (s) => String(s.Id) === String(selectedVendor.SourceId),
                      )?.SourceName ||
                        selectedVendor.SourceName ||
                        "—"}
                    </td>
                  </tr>
                  <tr>
                    <th>Company Name</th>
                    <td>{selectedVendor.CompanyName || "—"}</td>
                  </tr>
                  <tr>
                    <th>First Name</th>
                    <td>{selectedVendor.FirstName || "—"}</td>
                  </tr>
                  <tr>
                    <th>Last Name</th>
                    <td>{selectedVendor.LastName || "—"}</td>
                  </tr>
                  <tr>
                    <th>Contact</th>
                    <td>{selectedVendor.Contact || "—"}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{selectedVendor.Email || "—"}</td>
                  </tr>
                  <tr>
                    <th>Website</th>
                    <td>{selectedVendor.Website || "—"}</td>
                  </tr>
                  <tr>
                    <th>Country</th>
                    <td>{selectedVendor.Country || "—"}</td>
                  </tr>
                  <tr>
                    <th>Export Countries</th>
                    <td>{selectedVendor.ExportCountries || "—"}</td>
                  </tr>
                  <tr>
                    <th>Category</th>
                    <td>{selectedVendor.CategoryName || "—"}</td>
                  </tr>
                  <tr>
                    <th>Sub Category</th>
                    <td>{selectedVendor.Sub_Categories || "—"}</td>
                  </tr>
                  <tr>
                    <th>Priority</th>
                    <td>{selectedVendor.Priority || "—"}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{selectedVendor.Status || "—"}</td>
                  </tr>
                  <tr>
                    <th>Comments</th>
                    <td>{selectedVendor.Comments || "—"}</td>
                  </tr>
                </tbody>
              </table>
            )}
            {isEditMode && (
              <Form>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Source Name</Form.Label>
                      <Form.Select
                        value={editingVendor.SourceId}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            SourceId: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Source</option>
                        {sources.map((source) => (
                          <option key={source.Id} value={source.Id}>
                            {source.SourceName}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Company Name</Form.Label>
                      <Form.Control
                        value={editingVendor.CompanyName}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            CompanyName: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        value={editingVendor.FirstName}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            FirstName: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        value={editingVendor.LastName}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            LastName: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Contact</Form.Label>
                      <Form.Control
                        value={editingVendor.Contact}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            Contact: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        value={editingVendor.Email}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            Email: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Website</Form.Label>
                      <Form.Control
                        value={editingVendor.Website}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            Website: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Country</Form.Label>
                      <Form.Select
                        value={editingVendor.Country}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            Country: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Country</option>
                        {countries.map((country) => (
                          <option key={country.value} value={country.value}>
                            {country.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Category</Form.Label>
                      <Form.Select
                        value={editingVendor.CategoryId}
                        onChange={(e) => {
                          const newCategoryId = e.target.value;
                          setEditingVendor((prev) => ({
                            ...prev,
                            CategoryId: newCategoryId,
                            SubCategoryId: "",
                          }));
                        }}
                      >
                        <option value="">Select Category</option>
                        {categories.map((category) => (
                          <option
                            key={category.CategoryId}
                            value={category.CategoryId}
                          >
                            {category.Category}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Sub Category</Form.Label>
                      <Form.Select
                        value={editingVendor.SubCategoryId}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            SubCategoryId: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Sub Category</option>
                        {getSubCategoryOptions(editingVendor.CategoryId).map(
                          (subCategory) => (
                            <option key={subCategory.id} value={subCategory.id}>
                              {subCategory.name}
                            </option>
                          ),
                        )}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Export Countries</Form.Label>
                      <Select
                        isMulti
                        options={countries}
                        value={countries.filter((c) =>
                          selectedExportCountries.includes(c.value),
                        )}
                        onChange={(selectedOptions) => {
                          const selected = (selectedOptions || []).map(
                            (opt) => opt.value,
                          );
                          setSelectedExportCountries(selected);
                          setEditingVendor((prev) => ({
                            ...prev,
                            ExportCountries: selected.join(", "),
                          }));
                        }}
                        placeholder="Select export countries"
                        isClearable
                        closeMenuOnSelect={false}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Priority</Form.Label>
                      <Form.Select
                        value={editingVendor.Priority}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            Priority: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Priority</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        value={editingVendor.Status}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            Status: e.target.value,
                          }))
                        }
                      >
                        <option value="New">New</option>
                        <option value="Order Volumes & Prices Sent">
                          Order Volumes & Prices Sent
                        </option>
                        <option value="Waiting for Price & Volume Confirmation">
                          Waiting for Price & Volume Confirmation
                        </option>
                        <option value="Order Received">Order Received</option>
                        <option value="Porforma Invoice(PI) Sent">
                          Porforma Invoice(PI) Sent
                        </option>
                        <option value="PI Accepted">PI Accepted</option>
                        <option value="Order advanced payment Received">
                          Order advanced payment Received
                        </option>
                        <option value="Sent the shipping plan">
                          Sent the shipping plan
                        </option>
                        <option value="Shipped / Dispatched">
                          Shipped / Dispatched
                        </option>
                        <option value="Order Successful">
                          Order Successful
                        </option>
                        <option value="Other">Other</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Comments</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        value={editingVendor.Comments}
                        onChange={(e) =>
                          setEditingVendor((prev) => ({
                            ...prev,
                            Comments: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            {!isEditMode ? (
              <>
                <Button
                  variant="secondary"
                  onClick={() => setShowEditModal(false)}
                >
                  Close
                </Button>
                <Button variant="success" onClick={() => setIsEditMode(true)}>
                  <i className="bi bi-pencil-square me-1"></i>Edit
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="secondary"
                  onClick={() => setIsEditMode(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="success"
                  type="button"
                  onClick={handleSaveVendor}
                  disabled={isSavingVendor}
                >
                  {isSavingVendor ? "Saving..." : "Save Changes"}
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
          backdrop="static"
          style={{ zIndex: 1051 }} // Custom z-index to ensure modal is above the overlay
        >
          <Modal.Header closeButton>
            <Modal.Title>Actions for {selectedVendor?.CompanyName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleAddAction}>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Action</Form.Label>
                    <Form.Control
                      as="select"
                      value={newAction.Action}
                      onChange={(e) =>
                        setNewAction({ ...newAction, Action: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Action</option>
                      <option value="Order Volumes & Prices Sent">
                        Order Volumes & Prices Sent
                      </option>
                      <option value="Waiting for Price & Volume Confirmation">
                        Waiting for Price & Volume Confirmation
                      </option>
                      <option value="Order Received">Order Received</option>
                      <option value="Porforma Invoice(PI) Sent">
                        Porforma Invoice(PI) Sent
                      </option>
                      <option value="PI Accepted">PI Accepted</option>
                      <option value="Order advanced payment Received">
                        Order advanced payment Received
                      </option>
                      <option value="Sent the shipping plan">
                        Sent the shipping plan
                      </option>
                      <option value="Shipped / Dispatched">
                        Shipped / Dispatched
                      </option>
                      <option value="Order Successful">Order Successful</option>
                      <option value="Other">Other</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Remark</Form.Label>
                    <Form.Control
                      type="text"
                      value={newAction.Remark}
                      onChange={(e) =>
                        setNewAction({ ...newAction, Remark: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Button variant="success" type="submit" className="mt-3 w-100">
                Add Action
              </Button>
            </Form>

            <h5 className="mt-4">Previous Actions</h5>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Remark</th>
                  <th>Date & Time</th>
                </tr>
              </thead>
              <tbody>
                {actions.map((action) => (
                  <tr key={action.ActionId}>
                    <td>{action.Action}</td>
                    <td>{action.Remark || "N/A"}</td>{" "}
                    {/* Show N/A if Remark is null */}
                    <td>
                      {new Date(action.Date).toLocaleString("en-US", {
                        timeZone: "Asia/Colombo",
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                        hour12: true, // To display in 12-hour format (AM/PM)
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {/* end vt-page-card */}
    </div>
  );
};

export default VendorTable;
